<div class="row">
  <div class="col-12" *ngIf="showLicenseFilter && loadingFilter">
    <app-loading-spinner>Fetching licenses ...</app-loading-spinner>
  </div>

  <ng-container
    *ngIf="
      !loadingFilter &&
      showLicenseFilter &&
      licenses.length &&
      permissions.length
    "
  >
    <div class="col d-flex flex-wrap filter-wrapper" [@slideInOut]>
      <div class="row">
        <ng-container *ngFor="let license of permissions">
          <div class="col-xl-5 col-lg-7 col-md-9 col-sm-10 col-xs-12">
            <app-switch-checkbox
              bsClass="success"
              bsSize="sm"
              [checked]="
                selectedLicenses | toolPermissonCheckedPipe: license.code
              "
              (change)="showLicensesForPermission($event, license)"
            >
              {{ licenses | permissionNamePipe: license.code:licenses }}
            </app-switch-checkbox>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
<div
  class="row"
  *ngIf="
    !loadingFilter &&
    showLicenseFilter &&
    selectedLicenses &&
    selectedLicenses.length
  "
>
  <div class="col-12 offset-0 flex-wrap filter-wrapper advanced-secondary">
    <ng-container
      *ngFor="let license of selectedLicenses | licensesSelected: permissions"
    >
      <div class="row">
        <div class="col-12">
          <p class="label-for-licence-codes">
            {{ licenses | permissionNamePipe: license.code:licenses }}
          </p>
          <div class="filter-wrapper">
            <ng-container *ngFor="let permission of license.permissions">
              <app-switch-checkbox
                bsClass="success"
                bsSize="sm"
                [checked]="
                  selectedPermissions
                    | toolPermissonCheckedPipe: license.code + ':' + permission
                "
                (change)="
                  onShowUsersForLicensePermission(
                    $event,
                    permission,
                    license.code
                  )
                "
              >
                {{ permission }}
              </app-switch-checkbox>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
